import { createRouter as createTanStackRouter } from "@tanstack/react-router"
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query"
import { makeQueryClient } from "@/core/query"
import { routeTree } from "./routeTree.gen"

// TanStack Start router factory. Called once per request on the server (fresh
// QueryClient → no cross-request cache bleed) and once on the client at
// hydration. `routerWithQueryClient` wires SSR dehydrate → client hydrate so
// loader-prefetched queries arrive warm.
export function getRouter() {
  const queryClient = makeQueryClient()
  const router = createTanStackRouter({
    routeTree,
    context: { queryClient },
    // Preload route loaders on link-hover/touch ("intent"). The event-layout
    // loader (+ the per-leaf loaders in later waves) call
    // queryClient.ensureQueryData() to warm the surface's list queries, so
    // navigation lands on cached data instead of a loading flash.
    defaultPreload: "intent",
    // Query owns freshness: each queryOptions carries its own staleTime
    // (default 30s, see core/query.ts), so we don't want the router to add a
    // second staleness gate on top of ensureQueryData. 0 = always run the
    // loader on preload; ensureQueryData itself dedupes/returns cached data.
    defaultPreloadStaleTime: 0,
    scrollRestoration: true,
    defaultStructuralSharing: true,
  })
  setupRouterSsrQueryIntegration({ router, queryClient })
  return router
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
